import { ICanvasBannerPlaceholder } from "./CanvasBannerPlaceholder";
import { IFormat, FORMAT_VALIDATION_RULES } from "./Format";
import { IFormatParameter } from "./FormatParameter";

export interface IFormatVersion {
    id?: string;
    html?: string;
    dateCreated?: Date;
    isActive?: boolean;
    width?: string;
    height?: string;
    formatId?: string;
    format?: IFormat;
    formatParameters: IFormatParameter[];
    canvasBannerPlaceholders: ICanvasBannerPlaceholder[];
}

export class FormatVersion implements IFormatVersion {
    id?: string;
    html?: string;
    dateCreated?: Date;
    isActive?: boolean;
    width?: string;
    height?: string;
    formatId?: string;
    format?: IFormat;
    formatParameters: IFormatParameter[];
    canvasBannerPlaceholders: ICanvasBannerPlaceholder[];

    constructor();
    constructor(obj: IFormatVersion);
    constructor(obj?: IFormatVersion) {
        this.id = obj && obj.id || undefined;
        this.html = obj && obj.html || undefined;
        this.dateCreated = obj && obj.dateCreated || undefined;
        this.isActive = obj && obj.isActive || undefined;
        this.width = obj && obj.width || undefined;
        this.height = obj && obj.height || undefined;
        this.formatId = obj && obj.formatId || undefined;
        this.format = obj && obj.format || undefined;
        this.formatParameters = obj && obj.formatParameters || undefined;
        this.canvasBannerPlaceholders = obj?.canvasBannerPlaceholders || [];
    }
}

export const FORMATVERSION_VALIDATION_RULES: { html: ((v: any) => any)[], formatTitle: ((v: any) => any)[], format: ((v: IFormat) => any)[] } = {
    html: [
        v => !!v || 'HTML is required',
    ],
    formatTitle: FORMAT_VALIDATION_RULES.title,
    format: [
        v => !!v && !!v.id || 'Format type is required'
    ],
};